import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'

export default function BackButton() {
  const intl = useIntl()
  const navigate = useNavigate()
  let goBack = () => {
    navigate(-1)
  }
  return (
    <div>
      <button
        type='button'
        className='btn btn-sm btn-outline btn-outline-dark border-1 border-gray-300 '
        onClick={goBack}
      >
        {intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
      </button>
    </div>
  )
}
